import { Avatar, Box } from "@mui/material";
import React from "react";

const ImageAvatar = ({ src }) => (<Box display="flex" justifyContent="center" alignItems="center">
  <Avatar src={src} />
</Box>);

export default ImageAvatar;
